import { getOperatorOptions, getInclusionOptions } from '../logicHelpers'
import { countries } from '@/data/countries'

const locationSource = () => {
  return {
    types: [
      { label: 'Country', value: 'country' },
      { label: 'City', value: 'city' }
    ],
    inputs: [
      {
        $formkit: 'select',
        key: 'country-operator-select',
        name: 'operator',
        options: getInclusionOptions(),
        can: (condition: { $source: string; $type: string }) =>
          condition.$source === 'location' && condition.$type === 'country'
      },
      {
        $formkit: 'multiselect',
        key: 'country-select',
        name: 'value',
        multiple: true,
        'open-on-focus': true,
        'clear-search-on-open': true,
        options: countries,
        can: (condition: { $source: string; $type: string }) =>
          condition.$source === 'location' && condition.$type === 'country'
      },
      {
        $formkit: 'select',
        key: 'city-operator-select',
        name: 'operator',
        options: getOperatorOptions(),
        can: (condition: { $source: string; $type: string }) =>
          condition.$source === 'location' && condition.$type === 'city'
      },
      {
        $formkit: 'text',
        key: 'city-value-input',
        name: 'value',
        placeholder: 'Enter city name',
        can: (condition: { $source: string; $type: string }) =>
          condition.$source === 'location' && condition.$type === 'city'
      }
    ]
  }
}

export default locationSource
